import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import LoginForm from "./components/LoginForm";
import "./App.css";
import BasicLayout from "./components/BasicLayout";
import PrivateRoute from "./components/PrivateRoute";
import DashboardLayout from "./components/DashboardLayout";
import UserDetail from "./components/UserDetail";
import AttendancePage from "./components/AttendancePage";
import ThreeTabs from "./components/ThreeTabs";
import VerificationPage from "./components/VerificationPage";
import PanicPage from "./components/PanicPage";
import FacilityReportPage from "./components/FacilityReportPage";
import EventCalendar from "./components/EventCalendar";
import MaterialsPage from "./components/MaterialsPage";
import MaxFacilityReportPage from "./components/MaxFacilityReports";
import DetailGraphPage from "./components/DetailGraphPage";
import ManagementDashboard from "./components/ManagementDashboard";
import Component from "./components/Component";
import ERP_Page from "./components/ERP_Page";
import ReportsSummary from "./components/ReportsSummary";
import RM_Page from "./components/RMPage";
import FacilityReportSubmissionPage from "./components/FacilityReportSubmissionPage";
import MaterialsExcelPage from "./components/MaterialsExcelPage";
import FacilityReportSubmissionPage2 from "./components/ReportSubmissionPage2";
import FacilityReportType2Page from "./components/FacilityReportType2Page";
import FieldOfficerVisit from "./components/FieldOfficerVisit";
import BranchStatus from "./components/BranchStatus";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <BasicLayout>
              <LoginForm />
            </BasicLayout>
          }
        />
        <Route
          path="/login"
          element={
            <BasicLayout>
              <LoginForm />
            </BasicLayout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboardX"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <ManagementDashboard />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <AttendancePage />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <UserDetail />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/facility-report"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <FacilityReportPage />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/verification"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <VerificationPage />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/panic"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <PanicPage />
                {/* <h1>Panic</h1> */}
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/events"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <EventCalendar />
                {/* <h1>Panic</h1> */}
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/material"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <MaterialsPage />
                {/* <h1>Panic</h1> */}
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/max-facility"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <MaxFacilityReportPage />
                {/* <h1>Panic</h1> */}
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/facility-report-submission"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <FacilityReportSubmissionPage />
                {/* <h1>Panic</h1> */}
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/facility-report-type2"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <FacilityReportType2Page />
                {/* <h1>Panic</h1> */}
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route path="/about" element={<h1>About Page</h1>} />
        <Route
          path="/detail"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <DetailGraphPage />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route path="/component" element={<Component />} />
        <Route
          path="/erp-page"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <ERP_Page />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/reports-summary"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <ReportsSummary />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/RMPage"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <RM_Page />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/MaterialsPage"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <MaterialsExcelPage />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/FieldOfficerVisit"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <FieldOfficerVisit />
              </DashboardLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/BranchOpenClose"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <BranchStatus />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/checkInOut"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <BranchStatus />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        {/* <Route path="/attendance" element={<AttendanceTable />} /> */}
      </Routes>
    </div>
  );
}

export default App;
